import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

/**
 * Limited-preview feature access for the CALLER, computed server-side from
 * the tenant's `feature_previews` allowlist (see
 * backend/domain/featurePreviews.ts). The front end derives visibility from
 * this response — the allowlist itself never ships to the browser, and the
 * real enforcement is the backend's featurePreviewGuard on the gated routes.
 */
export type FeatureAccessResponse = {
  /** Internal cohort: the review drawer plus grading and config tooling. */
  pbqa_eval: boolean;
  /** Broker cohort: the review drawer only. */
  pbqa_review: boolean;
};

export const fetchFeatureAccess = async (): Promise<FeatureAccessResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/feature_access',
  });
  const { data } = await axios(networkPayload);
  return data;
};
